import React from "react";
import { IconButton, InputAdornment, TextField, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/SearchOutlined";
import CloseIcon from "@mui/icons-material/CloseOutlined";

// The Dashboard launchpad search box. It is its own glass container (the nav
// layout boxes the search and every nav item separately), so the outlined
// border is dropped and the glassBox surface itself reads as the field.
export default function DashboardSearchField({
  inputRef,
  value,
  autoFocus = false,
  onChange,
  onKeyDown,
  onClear,
}) {
  const theme = useTheme();
  return (
    <TextField
      inputRef={inputRef}
      autoFocus={autoFocus}
      fullWidth
      size="small"
      placeholder="Search…"
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      sx={{
        ...theme.custom.glassBox,
        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
        // Taller input so the search box matches the height of a boxed nav row
        // (which is ~46px from its py:1 + icon/add-button), keeping the search
        // and the menu items visually uniform.
        "& .MuiInputBase-input": { py: 1.5 },
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" sx={{ color: "#00000080" }} />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton
                size="small"
                aria-label="Clear search"
                onClick={onClear}
              >
                <CloseIcon fontSize="small" sx={{ color: "#00000080" }} />
              </IconButton>
            </InputAdornment>
          ) : null,
        },
        htmlInput: { "aria-label": "Search navigation" },
      }}
    />
  );
}
